module.exports = __webpack_public_path__ + "static/img/logo.362135d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newNmg/logo.png
// module id = R5q8
// module chunks = 1